import http from "../api";

export const getBusCompareData = async (data) => {
  const { dateFilter, filters } = data;
  let url = `/compare/buses?fromDate=${dateFilter?.fromDate}&toDate=${dateFilter?.toDate}`;
  if (filters && Object.keys(filters).length > 0) {
    Object.keys(filters).forEach((fl) => {
      url =
        url +
        `${
          filters[fl]?.agencyId && filters[fl]?.busId && filters[fl]?.key
            ? `&filters[${filters[fl]?.key}][agencyId]=${filters[fl]?.agencyId}&filters[${filters[fl]?.key}][busId]=${filters[fl]?.busId}&filters[${filters[fl]?.key}][busManufacturer]=${filters[fl]?.busManufacturer}`
            : ""
        }`;
    });
  }
  return await http.get(url);
};
